import StarRating from "@/components/widgets/star-rating";

export interface RatingBadgeProps {
	/** Rating value (e.g., 4.6, 5.0) */
	rating: number;
	/** Decimal places for display (needed because JSON parsing drops trailing zeros, e.g. 3.0 → 3) */
	precision?: number;
	/** Total number of testimonials/reviews */
	totalReviews: number;
	/** Badge background color */
	badgeColor?: string;
	/** Whether to show star icons */
	showStars?: boolean;
	/** Whether to show the review count */
	showCount?: boolean;
	/** Custom color for rating stars */
	ratingStarColor?: string;
	/** Text color for the rating tile number */
	ratingTileTextColor?: string;
	/** Background color for the rating tile */
	ratingTileBackgroundColor?: string;
	/** Text color for the review count */
	countTextColor?: string;
	/** Optional className for additional styling */
	className?: string;
}

export default function RatingBadge({
	rating,
	precision,
	totalReviews,
	badgeColor = "#1f1f1f",
	showStars = true,
	showCount = true,
	ratingStarColor,
	ratingTileTextColor,
	ratingTileBackgroundColor,
	countTextColor,
	className = "",
}: RatingBadgeProps) {
	return (
		<div className={`inline-flex m-auto items-center gap-5 justify-center ${className}`}>
			{/* Rating Score Badge */}
			<div
				className="flex items-center justify-center w-20 h-20 rounded-2xl text-white text-3xl font-bold"
				style={{ backgroundColor: ratingTileBackgroundColor || badgeColor, color: ratingTileTextColor }}
			>
				{precision !== undefined ? rating.toFixed(precision) : rating}
			</div>

			{/* Stars and Count */}
			{(showStars || showCount) && (
				<div className="flex flex-col gap-1">
					{showStars && <StarRating rating={rating} filledColor={ratingStarColor} />}

					{/* Review Count */}
					{showCount && (
						<p className="text-gray-600 text-lg" style={countTextColor ? { color: countTextColor } : undefined}>
							from{" "}
							<span className={`font-bold ${countTextColor ? "" : "text-gray-800"}`} style={countTextColor ? { color: countTextColor } : undefined}>
								{totalReviews.toLocaleString()}
							</span>{" "}
							testimonials
						</p>
					)}
				</div>
			)}
		</div>
	);
}
